<template>
  <el-dialog
    v-if="formData"
    :visible.sync="dialogVisible"
    custom-class="form-dialog"
    append-to-body
    :title="
      formData.id
        ? $t('shopDecoration.multimediaMaterial.editVideo')
        : $t('shopDecoration.multimediaMaterial.addVideo')
    "
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="分组" prop="saveGroupId">
        <!-- <el-select v-model="formData.meterialGroupId" filterable>
          <el-option
            v-for="item in groupsList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-cascader
          v-model="saveGroupId"
          placeholder="请选择商品分组"
          :options="groupsList"
          :props="{
            value: 'id',
            label: 'groupName',
            children: 'children',
            checkStrictly: true,
          }"
          clearable
          filterable
        >
          <template slot-scope="{ node, data }">
            <div class="cascader-view">{{ data.groupName }}</div>
            <!-- <dic v-if="!node.isLeaf">({{ data.children.length }})</dic> -->
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="标题" prop="materialName">
        <el-input
          v-model="formData.materialName"
          :maxlength="15"
          show-word-limit
        >
          <template v-if="tempType" slot="append">{{ tempType }}</template>
        </el-input>
      </el-form-item>

      <el-form-item label="视频">
        <el-upload
          class="upload-demo"
          :file-list="fileList"
          :action="actionUrlCustom"
          :headers="uploadHeaders"
          :accept="acceptByType"
          :limit="limit"
          :on-exceed="handleExceed"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :before-upload="beforeFileUpload"
          :before-remove="beforeRemove"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          list-type="text"
          drag
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <p slot="tip">
            注意：
            <br />
            <span>
              1. 视频上传支持mp4格式;
            </span>
            <br />
            <span>
              2. 仅支持最大{{ maxFileSize }}M，建议时长9-30秒，建议宽高比16:9
            </span>
          </p>
        </el-upload>
      </el-form-item>
      <!-- 封面 -->
      <el-form-item label="封面">
        <cover-upload ref="coverUpload"></cover-upload>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">
        {{ $t('shopDecoration.home.controls.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirm">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import CoverUpload from './cover-upload.vue';
import editDialog from '@/mixins/edit-dialog';
import elUpload from '@/mixins/el-upload';

export default {
  components: { CoverUpload },
  mixins: [editDialog, elUpload],
  props: {
    editItem: {
      type: Object,
      required: true,
    },
    groupsList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      actionUrlCustom: this.$http.defaults.baseURL + '/business/common/file/uploadPandV',
      limit: 1,
      maxFileSize: 30,
      saveGroupId: [],
      // acceptType: 'video',
      customAccept: ['mp4'],
      formData: null,
      rules: {
        meterialGroupId: {
          required: true,
        },
        // materialName: {
        //   type: 'string',
        //   required: true,
        //   message: this.$t(
        //     'shopDecoration.multimediaMaterial.materialNameRequired'
        //   ),
        // },
      },
    };
  },
  watch: {
    dialogVisible(v) {
      if (!v) {
        this.fileList = [];
        this.$refs.coverUpload.clear();
      }
    },
    editItem: {
      handler(v) {
        this.formData = _.cloneDeep(v);

        const findTree = (val, arr) => {
          if (val.id == 0) {
            return [];
          }
          if (this.formData.meterialGroupId == val.id) {
            return [...arr, val.id];
          }
          if (val.children !== null) {
            for (let v of val.children) {
              return findTree(v, [...arr, val.id]);
            }
          } else {
            return [];
          }
        };
        if (this.groupsList.length > 0) {
          for (let val of this.groupsList) {
            const fin = findTree(val, []);
            if (fin.length > 0) {
              this.saveGroupId = fin;
              break;
            }
          }
        }

        // 回显
        if (this.formData.id) {
          // 处理name
          if (
            this.formData.materialName &&
            this.formData.materialName.includes('.')
          ) {
            const res = this.formData.materialName.match(/(.*)\.(.+)/);
            this.formData.materialName = res[1];
            this.tempType = '.' + res[2];
          } else {
            // old data
            this.tempType = '.' + this.formData.fileName.match(/.*\.(.+)/)[1];
          }
          this.fileList = [
            {
              name: this.formData.fileName,
              url: this.imageUrl + this.formData.videoUrl,
            },
          ];
          this.$nextTick(() => {
            this.$refs.coverUpload.setFile({
              name: this.formData.pictureUrl,
              url: this.imageUrl + this.formData.pictureUrl,
            });
          });
        } else {
          this.tempType = '';
        }
      },
      immediate: true,
    },
  },
  computed:{
    requestPre(){
      return this.sellerBookingType === 1 ? '/bookingAdmin' : ''
    }
  },
  methods: {
    handleUploadSuccess(res) {
      // 视频上传后,封面同步

      const strList = this.fileList[0].name.match(/(.*)\.(.+)/);
      this.formData.materialName = strList[1].slice(0, 15);
      this.tempType = '.' + strList[2];
      this.$refs.coverUpload.setFile({
        name: res.data.pictureUrl,
        url: this.imageUrl + res.data.pictureUrl,
      });
    },
    confirm() {
      if (Array.isArray(this.saveGroupId) && this.saveGroupId.length > 0) {
        this.formData.meterialGroupId = this.saveGroupId[
          this.saveGroupId.length - 1
        ];
      }

      this.$refs.form.validate(valid => {
        if (!valid) return;
        const videoFile = this.fileList[0];
        const isUploading =
          videoFile && !this.formData.id && !videoFile.response; // 上传中的状态判断
        if (!videoFile || isUploading) {
          this.$message.info(
            this.$t('shopDecoration.multimediaMaterial.fileRequired')
          );
          return;
        }

        // 视频
        let fileParams = {};
        if (videoFile.response) {
          fileParams = {
            fileName: videoFile.name,
            materialSize: videoFile.size,
            width: videoFile.response.data.width,
            height: videoFile.response.data.height,
            // response > old
            videoUrl: videoFile.response.data.videoUrl,
          };
        }
        // 封面
        const coverUploadFile = this.$refs.coverUpload.getFileUrl();

        const url = this.formData.id
          ? `${this.requestPre}/sellerMaterial/update`
          : `${this.requestPre}/sellerMaterial/save`;

        const originParams = {
          ...this.formData,
          ...fileParams,
          materialName: this.formData.materialName
            ? this.formData.materialName + this.tempType
            : '',
          pictureUrl: coverUploadFile,
          type: CONST.MATERIAL_TYPE.video,
        };
        const params = this.formData.id
          ? {
              sellerMaterialList: [originParams],
            }
          : [originParams];

        this.$http
          .post(url, params, {
            showLoading: true,
          })
          .then(res => {
            // saveGroupId

            if (res.data.success) {
              this.$message.success('保存成功！');
              this.close();
              this.$emit('edited', {
                meterialGroupId: this.formData.meterialGroupId,
              });
            } else {
              this.$message.warning(res.data.message);
            }
          });
      });
    },
    handleEditedShop() {
      this.$emit('edited');
    },
  },
};
</script>

<style scoped>
::v-deep .el-upload-dragger {
  width: 146px;
  height: 148px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-upload-dragger ::v-deep {
  width: 146px;
  height: 148px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="scss" scoped>
.upload-demo {
  ::v-deep .el-upload-dragger {
    width: 146px;
    height: 148px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
::v-deep .el-upload-dragger {
  width: 146px;
  height: 148px;
  display: flex;
  justify-content: center;
  align-items: center;
}
// .el-upload-dragger
//
</style>
